// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dispatchNotificationEvent, FileType } from "..";
import { newSystFromMolObj } from "../3dViewer/Selection/newSystFromMolObj";
export const addMoleculeFromConsole = (vss, molstar, pyodide, moleculeID) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        //1. Get mol data
        const res = yield pyodide.RunPythonAsync({
            context: { moleculeID },
            script: `
        from js import moleculeID
        mol_data={} 
        syst = systems.get(moleculeID, None)
        if syst:
            mol = syst.get("molecule", None)
            if mol: 
                mol_data = _get_mol_info(mol)
        mol_data
    `,
        });
        //2. Define new system
        const system = {
            name: res.name || "System",
            type: res.isTrajectory
                ? FileType.trajectory
                : res.isSDF
                    ? FileType.sdf
                    : FileType.coordinates_single,
            // representations: newToSystemReps,
            files: [],
            moleculeID: moleculeID,
        };
        //3. Generate molkit molecule and molstar model
        yield newSystFromMolObj(molstar, pyodide, system, res.isSDF, "", moleculeID);
        //4. Update system tree
        if (system.cellRef) {
            vss.getState().add_loaded_structure(system);
        }
        else {
            throw new Error("Error creating the new system.");
        }
    }
    catch (error) {
        console.error(error);
        dispatchNotificationEvent({
            message: "Error loading new system.",
            type: "error",
        });
    }
});
